<template>
  <div style="position: relative;" @click="focusInput" class="j-input-number-wrapper">
    <!-- hong@2020-08-26 修改为不做任何预处理 -->
    <!-- :parser="value => parserAction(value)"
    @input.native="inputChangefocus($event)" -->
    <a-input-number
      ref="jInputNumber"
      v-model="myValue"
      class="j-input-number"
      :class="[suffix ? 'suffix' : '']"
      style="width: 100%;"
      :autoFocus="autoFocus"
      :disabled="disabled"
      :max="max"
      :min="min"
      :precision="precision"
      :decimalSeparator="decimalSeparator"
      :size="size"
      :step="step"
      :formatter="value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')"
      :parser="value => value.replace(/\$\s?|(,*)/g, '')"
      @change="onChange"
      @keyup.enter.stop
    />
    <span v-if="placeholderShow" class="placeholder">{{ placeholder }}</span>
    <span :class="[disabled ? 'suffix-disabled' : '']" style="position: absolute;right: 26px;z-index: 1;">{{
      suffix
    }}</span>
  </div>
</template>

<script>
/******
 *<j-input-number
 * suffix="元"
 * :min="1"
 * :max="1000"
 * v-decorator="['decoratorMin', { rules: [{ required: true, message: 'message'},],initialValue: 2 },]"
 * ></j-input-number>
 *
 *
 * suffix: 后缀文字
 * min: 存在时，输入框必有值
 *
 * v-decorator 作为表单验证时 使用
 *
 * v-modle 常用
 *
 */
export default {
  name: 'JInputNumber',
  props: {
    value: {
      type: Number
    },
    required: {
      type: Boolean,
      default: false
    },
    autoFocus: {
      type: Boolean,
      default: false
    },
    defaultValue: {
      type: Number
    },
    disabled: {
      type: Boolean,
      default: false
    },
    suffix: {
      type: String
    },
    max: {
      type: [Number, String],
      default: 9999999999999999
    },
    min: {
      type: [Number, String],
      default: 0
    },
    precision: {
      type: Number,
      default: 0
    },
    decimalSeparator: {
      type: String
    },
    size: {
      type: String
    },
    step: {
      type: [Number, String],
      default: 1
    },
    formatter: {
      type: Function,
      default: value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },
    parser: {
      type: Function,
      default: value => value.replace(/\$\s?|(,*)/g, '')
    },
    placeholder: {
      type: String
    }
  },
  data() {
    return {
      myValue: this.value,
      oldValue: this.value,
      requiredFlg: ''
    }
  },
  watch: {
    value() {
      this.myValue = this.value
    }
  },
  computed: {
    placeholderShow: {
      get() {
        if (this.value || this.value == 0) {
          return false
        } else {
          return true
        }
      },
      set(val) {}
    }
  },
  created() {
    if (this.isRequired() && !this.myValue) {
      if (this.min > 0) {
        this.myValue = this.min
      } else {
        this.myValue = 0
      }
      this.oldValue = this.myValue
      // v-model
      this.$emit('input', this.myValue)
      // v-decorator
      this.$emit('change', this.myValue)
    }
  },
  methods: {
    inputChangefocus(e) {
      console.info('before blur:' + this.myValue)
      if (this.myValue != '-') {
        e.srcElement.blur()
        console.info('after blur:' + this.myValue)
        // if (this.min != null) {
        //   if (this.myValue == null) {
        //     this.myValue = this.min
        //   }
        // }
        e.srcElement.focus()
      }
    },
    parserAction(value) {
      //let reg = /(?:0|\-?(?:0\.\d*[1-9]|[1-9]\d*(?:\.\d*[1-9])?))/g
      var reg = ''
      if (this.step >= 1) {
        reg = /([0-9-])/g
      } else {
        reg = /([0-9-.])/g
      }

      if (this.step && this.step < 1) {
        var decimals = this.step.toString().split('.')[1].length
      }

      let val = ''
      let str = value + ''
      let arr = str.match(reg)
      if (arr) {
        arr.forEach((item, index) => {
          if (this.step < 1) {
            if (arr.indexOf('.') + decimals >= index) {
              val += item
            }
          } else {
            val += item
          }
        })
      }
      return val
    },
    onChange(value) {
      // hong@2020-08-26 修改为不做任何预处理
      //非负浮点数
      var regPos = /^\d+(\.\d+)?$/
      //负浮点数
      var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/
      console.info('before emit: ' + this.myValue)
      if (this.myValue == '' || this.myValue == null || regPos.test(this.myValue) || regNeg.test(this.myValue)) {
        console.info('emit: ' + this.myValue)
        // v-model
        this.$emit('input', this.myValue == null || this.myValue.toString() == '' ? null : this.myValue)
        // v-decorator
        this.$emit('change', this.myValue == null || this.myValue.toString() == '' ? null : this.myValue)
      }

      // var that = this
      // setTimeout(function() {
      //   let str = value + ''
      //   let reg = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/
      //   if (str == '' && that.isRequired()) {
      //     if (that.min > 0) {
      //       that.myValue = that.min
      //     } else {
      //       that.myValue = 0
      //     }
      //     that.oldValue = that.myValue
      //     // v-model
      //     that.$emit('input', that.myValue)
      //     // v-decorator
      //     that.$emit('change', that.myValue)
      //   } else if (str == '' || reg.test(str)) {
      //     // console.info('setted to ' + that.myValue)
      //     // if (that.step && that.step < 1) {
      //     //   var decimals = that.step.toString().split('.')[1].length
      //     //   var strValue = that.myValue.toString()

      //     //   if (strValue.indexOf('.') < 0) {
      //     //     that.myValue = that.myValue + '.' + ''.padEnd(decimals, '0')
      //     //   } else {
      //     //     var after =
      //     //       strValue.split('.')[1].length > decimals
      //     //         ? strValue.split('.')[1].substring(0, decimals)
      //     //         : strValue.split('.')[1].padEnd(decimals, '0')
      //     //     that.myValue = Number(strValue.split('.')[0] + '.' + after)
      //     //   }
      //     // }

      //     that.oldValue = that.myValue
      //     // v-model
      //     that.$emit('input', that.myValue)
      //     // v-decorator
      //     that.$emit('change', that.myValue)
      //   } else {
      //     // console.info('reverted from ' + that.myValue + ' to ' + that.oldValue)
      //     // v-model
      //     that.$emit('input', that.oldValue)
      //     // v-decorator
      //     that.$emit('change', that.oldValue)
      //   }
      // }, 1)
    },
    isRequired() {
      if (this.requiredFlg == 'true') {
        return true
      } else if (this.requiredFlg == 'false') {
        return false
      } else if (this.required) {
        this.requiredFlg = 'true'
        return true
      } else {
        var isRequired = false
        if (this.$attrs['data-__meta'] && this.$attrs['data-__meta'].validate) {
          this.$attrs['data-__meta'].validate.map(item0 => {
            if (item0.rules) {
              item0.rules.map(item1 => {
                if (item1.required) {
                  isRequired = true
                }
              })
            }
          })
        }
        this.requiredFlg = isRequired ? 'true' : 'false'
        return isRequired
      }
    },
    onBlur() {
      if (this.myValue != 0 && this.myValue) {
        this.placeholderShow = true
      }
    },
    focusInput() {
      this.$refs.jInputNumber.$el.querySelector('.ant-input-number-input').focus()
    }
  },
  model: {
    prop: 'value',
    event: 'change'
  }
}
</script>

<style lang="less" scoped>
.j-input-number {
  background: #fff;
}
.suffix {
  padding-right: 18px;
  width: 100%;
}
.j-input-number.ant-input-number-disabled {
  /deep/ .ant-input-number-handler-wrap {
    display: block;
    .ant-input-number-handler-down,
    .ant-input-number-handler-up {
      cursor: not-allowed;
      color: rgba(0, 0, 0, 0.25) !important;
      background-color: #f5f5f5 !important;
      border-color: #d9d9d9 !important;
    }
  }
}
.suffix-disabled {
  color: rgba(0, 0, 0, 0.25) !important;
}
.placeholder {
  position: absolute;
  left: 8px;
  background: transparent;
  color: #c4c4c4;
  z-index: 1;
}
</style>
